import { render, staticRenderFns } from "./businessUnitManagement.vue?vue&type=template&id=45ab0a1c&scoped=true"
import script from "./businessUnitManagement.vue?vue&type=script&lang=js"
export * from "./businessUnitManagement.vue?vue&type=script&lang=js"
import style0 from "./businessUnitManagement.vue?vue&type=style&index=0&id=45ab0a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ab0a1c",
  null
  
)

export default component.exports